module.exports = __webpack_public_path__ + "img/parttwo_pic1.b60d94b7.png";